import { call, put, takeLatest } from "redux-saga/effects";
import { notification } from "antd";
import { POST } from "../../api";
import ApiRouts from "../../api/routes";
import {  FETCH_FORGET_PASSWORD } from "../actions";
import { setForgetPassword } from "./action";
import { t } from "i18next";

function* fetchForgetPasswordSaga(action) {
    console.log(action , 'forget')
    try {
        const response = yield call(POST, `${ApiRouts.API_FORGET_PASSWORD}`, action.payload.forgetPasswordData);
        if (response) {
            yield put(setForgetPassword(response.data));
            notification.success({
                message: t('messages.succes_forget_password'),
                description: response?.data?.message || "Something went wrong!",
                placement: "topRight",
            });

        } else {
            throw new Error("Failed to fetch the banner.");
        }
    } catch (error) {
        notification.error({
            message: t('messages.failed_forget_password'),
            description: error.response?.data?.message || "Something went wrong!",
            placement: "topRight",
        });
    }
}

function* forgetPasswordSaga() {
    yield takeLatest(FETCH_FORGET_PASSWORD, fetchForgetPasswordSaga);
}


export default forgetPasswordSaga;
